// testdomain.component.ts
import { Component } from '@angular/core';

@Component({
  selector: 'app-testdomain',
  templateUrl: './test-domain.component.html'
})
export class TestDomainComponent {
    domain = window.location.hostname;
}